import type React from 'react';

/**
 * Config-driven action-key -> label convention for kebab (ThreeDotMenu) CTAs,
 * mirroring the existing secondCTATrigger pattern (ActionButton.getButtonLabel /
 * HeaderButtonContainer.ACTION_MENU_MAP): the backend hands the FE an array of
 * action keys (e.g. leadsCtaAction/dealsCtaAction, siblings of
 * firstCTATrigger/secondCTATrigger under dashboardConfig.actionConfig), and the
 * FE maps each key to a display label here.
 */
export const CTA_ACTION_LABELS: Record<string, string> = {
    EXPORT_XLSX: 'Export .xlsx',
};

export const EXPORT_XLSX_ACTION_KEY = 'EXPORT_XLSX';

export const VIEW_APPLICATION_FORM_ACTION_KEY = 'VIEW_APPLICATION_FORM';

export type CtaMenuItem = { name: React.ReactNode; onClick: () => void; keepOpenOnClick?: boolean };

/**
 * Builds ThreeDotMenu items from a config-driven action-key array. Keys the
 * caller hasn't wired a handler for (via `handlers`) are silently skipped —
 * config-membership is the gate, same as the existing secondCTATrigger CTAs.
 */
export function buildCtaActionMenuItems(
    actionKeys: string[] | undefined,
    handlers: Record<string, { onClick: () => void; label?: React.ReactNode; keepOpenOnClick?: boolean } | undefined>,
): CtaMenuItem[] {
    return (actionKeys || []).reduce<CtaMenuItem[]>((items, key) => {
        const handler = handlers[key];
        const label = handler?.label ?? CTA_ACTION_LABELS[key];
        if (handler && label) {
            items.push({ name: label, onClick: handler.onClick, keepOpenOnClick: handler.keepOpenOnClick });
        }
        return items;
    }, []);
}
